import { withAppInsights } from '@exxonmobil/uit-uda-ui-components-lib';
import { api } from 'helpers/api';
import {
  ApiServiceFunctionParams,
  createApiHook
} from 'helpers/apiResponseStateUpdate';
// import { delay } from 'lodash';
import {
  BaselinesData,
  UpdateBaselinePayload,
  AddBaselinePayload
} from 'models/baselines';

const { REACT_APP_WORKSCHEDULERESOURCES_API_BASE_URL } = process.env;

const resourceLocation = {
  collectionName: 'uda-baselines',
  resourceId: ''
};

const cacheOptions = {
  disableCache: true
};

export type GetBaselinesStateDataType = any[];
export type GetBaselinesParams = {};
export const initBaselinesData = [];

const initUpdateBaseline = {
  id: '',
  approved: [],
  requested: [],
  workCenter: ''
};

type UpdateBaselineParams = {
  id: string;
  updateBaselinePayload: UpdateBaselinePayload;
};
export const useUpdateBaselineApi = createApiHook<
  UpdateBaselineParams,
  typeof initUpdateBaseline
>({
  initStateDataValue: initUpdateBaseline,
  apiServiceFunction: async (
    params: ApiServiceFunctionParams<UpdateBaselineParams>
  ): Promise<Response> => {
    return withAppInsights(async () => {
      const { id, updateBaselinePayload } = params;
      const response = await api.patch({
        url: `${REACT_APP_WORKSCHEDULERESOURCES_API_BASE_URL}/baselines/${id}/requested`,
        body: updateBaselinePayload,
        resourceLocation
      });
      return response;
    });
  }
});

type AddBaselineParams = {
  addBaselinePayload: AddBaselinePayload;
};

export const useAddBaselineApi = createApiHook<
  AddBaselineParams,
  typeof initUpdateBaseline
>({
  initStateDataValue: initUpdateBaseline,
  apiServiceFunction: async (
    params: ApiServiceFunctionParams<AddBaselineParams>
  ): Promise<Response> => {
    return withAppInsights(async () => {
      const { addBaselinePayload } = params;
      const response = await api.post({
        url: `${REACT_APP_WORKSCHEDULERESOURCES_API_BASE_URL}/baselines`,
        body: addBaselinePayload,
        resourceLocation
      });
      return response;
    });
  }
});

export const getBaselines = async (): Promise<BaselinesData[]> => {
  return withAppInsights(async () =>
    api.get({
      url: `${REACT_APP_WORKSCHEDULERESOURCES_API_BASE_URL}/baselines`,
      cacheOptions,
      resourceLocation
    })
  );
};

export const approveWorkCenterBaselines = async (
  id: string
): Promise<Response> => {
  const response = await api.patch({
    url: `${REACT_APP_WORKSCHEDULERESOURCES_API_BASE_URL}/baselines/${id}/approve`,
    body: '',
    resourceLocation
  });

  return response;
};

export const updateWorkCenterBaselines = async (
  id: string,
  updateBaselinePayload: UpdateBaselinePayload
): Promise<Response> => {
  const response = await api.patch({
    url: `${REACT_APP_WORKSCHEDULERESOURCES_API_BASE_URL}/baselines/${id}/requested`,
    body: updateBaselinePayload,
    resourceLocation
  });

  return response;
};
